import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserAvatarComponent} from './user-avatar.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
        SummaryFieldModule,
    ],
    declarations: [
        UserAvatarComponent,
    ],
    exports: [
        UserAvatarComponent
    ],
})
export class UserAvatarModule{}
